// What an interaction did to the world, on its way to the renderer.
//
// Renamed and widened from `altarEffect.ts` (2026-08-13). That module carried
// one object id, for one branch: after `resolveInteractText` consumed a
// `placeItemId`, it told the running GameScene which object had just had its
// item placed, and the scene *did the mutation* -- writing `altar.filled`,
// swapping the interact, and settling. That listener was the last piece of
// world state being written from the renderer.
//
// The mutations now happen in `sim/interact.ts`, where every other mutation in
// this project happens, so what crosses this bridge is no longer an id to act
// on but the `SimEvent`s that acting produced. The scene applies them through
// the same `applySimEvents` every cast and step already goes through.
//
// Widening it is what makes room10's Portal appear at the moment the fourth
// crystal goes in. `applyInteract` settles, and settling is where
// `checkRuneAltars` swaps the Rune Circle for the Portal -- an `object-removed`
// and an `object-added`. Under the old bridge those events were produced inside
// the scene's own `settle()` call; under this one they are produced in the sim
// and would simply have been dropped, leaving the Portal invisible until the
// player left the room and came back.
//
// Same pub/sub shape as `roomJump.ts`, `dpadInput.ts` and `turnActions.ts`, and
// for the same reason those give: ui.ts owns the DOM and has no scene
// reference, the scene owns the world and has no reason to reach into raw DOM.
import { SimEvents } from '../../rune-lab/src/sim/events';

const listeners: Array<(events: SimEvents) => void> = [];

export function onInteractEffects(listener: (events: SimEvents) => void): void {
  listeners.push(listener);
}

export function triggerInteractEffects(events: SimEvents): void {
  listeners.forEach((listener) => listener(events));
}
